import { render } from "./ReportPositions.vue?vue&type=template&id=dffe8b64"
import script from "./ReportPositions.vue?vue&type=script&lang=js"
export * from "./ReportPositions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportPositions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dffe8b64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dffe8b64', __exports__)) {
    console.log('reload')
    api.reload('dffe8b64', __exports__)
  }
  
  module.hot.accept("./ReportPositions.vue?vue&type=template&id=dffe8b64", () => {
    console.log('re-render')
    api.rerender('dffe8b64', render)
  })

}


export default __exports__